import React, { useEffect, useRef, useState } from "react";
import nascosti from "../../fakedata/nascosti.json";
import "../../scss/virtuali.scss";
import GameComponent from "../../components/games/GameComponent";
import { Game, GetGameQuery } from "../../API";
import { GRAPHQL_AUTH_MODE, GraphQLResult } from "@aws-amplify/api-graphql";
import { API } from "aws-amplify";
import { getGame } from "../../graphql/queries";

const Nascosti: React.FC = () => {
  const [games, setGames] = useState<Array<Game>>([]);
  const [gameProviders, setGameProviders] = useState<Array<String>>([]);
  useEffect(() => {
    let aGame: Array<Game> = [];
    console.log(nascosti);
    nascosti.map((n, i) => {
      console.log(n);
      (async () => {
        const g: GraphQLResult<GetGameQuery> = (await API.graphql({
          query: getGame,
          authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          variables: {
            PK: n.PK,
            SK: n.SK,
          },
        })) as GraphQLResult<GetGameQuery>;
        if (g.data) {
          aGame = [...aGame, { ...(g.data.getGame as Game) }];
          if (!gameProviders.includes(g.data.getGame.category)) {
            setGameProviders([...gameProviders, g.data.getGame.category]);
          }
          setGames(aGame);
        }
      })();
    });
  }, []);

  return (
    <div className="virtual-body-content hpage">
      {gameProviders.map((p, i) => {
        return (
          <div key={`provider-${i}`} className="virtual-game-provider">
            <span className="virtual-game-provider-name">{p}</span>
            <hr />
            <div className="provider-games provider-games-4">
              {games.map((n, i) => {
                const gData = JSON.parse(n.gamedata);
                console.log(n, gData);
                return (
                  <GameComponent
                    key={`game-${i}`}
                    title={gData.title}
                    image={gData.details.thumbnails["300x300"]}
                    provider={String(p)}
                    operator={n.apiOperator}
                    urlEndPoint={n.urlEndPoint}
                    gameId={n.id}
                    nascosti={true}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Nascosti;
